module.exports = __webpack_public_path__ + "static/media/16UNODC13.d4f12c21.jpg";